export var Lang;
(function (Lang) {
    Lang["ZH_TW"] = "zh-TW";
    Lang["ZH_CN"] = "zh-CN";
    Lang["EN_US"] = "en-US";
})(Lang || (Lang = {}));
//# sourceMappingURL=Lang.js.map